import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  ProductGroup,
  productGroupResource,
} from "@megarax/client/src/resources/plm";

export const productGroupModule: ResourceAppModule = {
  app: plmApp,
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  title: "Grupy produktowe",
  route: "productGroup",
  itemConstructor: ProductGroup,
  resource: productGroupResource,
};
